<template>
  <app-content>
    <page-title>Anmelden</page-title>
    <main id="login">
      <div class="container">
        <login-form/>
      </div>
    </main>
  </app-content>
</template>

<script>
import Vue from 'vue';

import AppContent from '@/components/technical/AppContent.vue';
import PageTitle from '@/components/PageTitle.vue';
import LoginForm from '@/components/forms/LoginForm.vue';

export default {
  name: 'Login',

  components: {
    AppContent,
    PageTitle,
    LoginForm,
  },

  beforeRouteEnter(to, from, next) {
    Vue.axios.get('/api/invitee')
      .then(() => next({
        name: 'gallery',
      }))
      .catch(() => next());
  },
};
</script>

<style lang="scss">
  #login {
    flex: 1 0 auto;
    padding: 1.5rem;

    text-align: left;
  }

  .form-container {
    max-width: 1000px;
    margin: auto;
    text-align: initial;
  }
</style>
